import { apiClient } from "./httpClient";
import { unwrapEnvelope } from "./response";

export const approvalAnalyticsApi = {
  async summary(params = {}) {
    const response = await apiClient.get("/analytics/approvals/summary", { params });
    return unwrapEnvelope(response.data, {});
  },

  async byRole(params = {}) {
    const response = await apiClient.get("/analytics/approvals/by-role", { params });
    return unwrapEnvelope(response.data, { items: [] });
  },

  async byEntity(params = {}) {
    const response = await apiClient.get("/analytics/approvals/by-entity", { params });
    return unwrapEnvelope(response.data, { items: [] });
  },

  async timeline(params = {}) {
    const response = await apiClient.get("/analytics/approvals/timeline", { params });
    return unwrapEnvelope(response.data, { items: [] });
  }
};
